/* =========================================================================
   SAMSARA — SECTION-PAGE-BREWING-CALCULATOR.JS
   Interactive recipe calculator pe brew guide pages.
   Profile state: sweet / balanced / bright → swap recipe params + tips.
   Troubleshoot per metodă — independent de profil.
   ========================================================================= */

(function () {
  'use strict';

  const TROUBLESHOOT_COMMON = {
    bitter: {
      symptom: 'Prea amară / arsă',
      cause: 'Over-extraction — măcinare prea fină, apă prea fierbinte sau timp prea lung.',
      fix: 'Grind mai grosier (1 click). Scade temp 2°C. Reduce timpul total.'
    },
    sour: {
      symptom: 'Prea acidă / sour',
      cause: 'Under-extraction — măcinare grosieră, temp joasă sau bloom scurt.',
      fix: 'Grind mai fin. Ridică temp 2°C. Prelungește bloom-ul la 45s.'
    },
    weak: {
      symptom: 'Slabă / apoasă',
      cause: 'Ratio diluat sau dose insuficientă; cafea over-degazată (>21 zile).',
      fix: 'Crește doza 10% sau scade apa. Folosește cafea sub 14 zile post-prăjire.'
    },
    flat: {
      symptom: 'Plată, fără aromă',
      cause: 'Apă fără minerale (distilată/RO), cafea veche sau temp prea joasă.',
      fix: 'Apă filtrată cu calcar 60-80 ppm. Verifică data prăjirii. Temp 92-94°C.'
    },
    astringent: {
      symptom: 'Astringentă / usucă gura',
      cause: 'Tanin extras agresiv — temp peste 95°C, prăjire light + timp lung.',
      fix: 'Scade temp la 90°C. Grind mai grosier. Servește la 65-70°C.'
    }
  };

  const RECIPES = {
    v60: {
      sweet: {
        dose: '15g', water: '250ml', ratio: '1:16.7',
        temp: '88°C', grind: 'Medie-grosieră', time: '3:00 — 3:30',
        steps: [
          'Pre-umezește filtrul Hario cu apă caldă; aruncă apa.',
          'Adaugă 15g cafea. Bloom cu 30g apă (45s).',
          'Toarnă lent: 60g → pauză 20s → 90g → pauză 20s → 70g final.',
          'Așteaptă să se scurgă complet. Total 3:00–3:30.'
        ],
        tipsDo: [
          'Temperatură 88°C pentru cafele co-fermentate/anaerobe.',
          'Filtru subțire — păstrează body cu claritate.',
          'Apă filtrată, mineralizare moderată (calcar 60–80 ppm).'
        ],
        tipsDont: [
          'NU folosi apă boiling (>92°C) — extrage tanin.',
          'NU agita după bloom — disturbe extracția.',
          'NU schimba ratio fără să adaptezi grind-ul.'
        ]
      },
      balanced: {
        dose: '15g', water: '250ml', ratio: '1:16.7',
        temp: '92°C', grind: 'Medie', time: '2:45 — 3:15',
        steps: [
          'Pre-umezește filtrul, aruncă apa.',
          '15g cafea + bloom 30g apă (45s).',
          'Toarnă în 3 reprize uniform: 80g + 80g + 60g (intervale 30s).',
          'Total 2:45–3:15.'
        ],
        tipsDo: [
          'Setting standard pentru single origins washed.',
          'Bloom 45s e cheia — degazarea iese complet.',
          'Cronometrează — flow consistent = extracție uniformă.'
        ],
        tipsDont: [
          'NU sări peste bloom — gazul reține aroma în bob.',
          'NU toarna agresiv în centru — channeling.',
          'NU folosi cafea peste 21 zile post-prăjire.'
        ]
      },
      bright: {
        dose: '15g', water: '240ml', ratio: '1:16',
        temp: '94°C', grind: 'Medie-fină', time: '2:30 — 3:00',
        steps: [
          'Pre-umezește filtrul.',
          '15g cafea + bloom 30g (30s).',
          '3 reprize rapide: 100g + 110g (intervale 20s).',
          'Total 2:30–3:00 — extracție rapidă, aciditate clean.'
        ],
        tipsDo: [
          'Temperatură ridicată scoate fruct citric complet.',
          'Grind mai fin compensează timpul scurt.',
          'Ideal pentru washed African (Kenya, Etiopia).'
        ],
        tipsDont: [
          'NU folosi acest profil pe co-fermentate — devine astringent.',
          'NU prelungi timpul — peste 3:30 devine sour.',
          'NU folosi pe medium-dark roast — temp prea mare.'
        ]
      },
      troubleshoot: [
        TROUBLESHOOT_COMMON.bitter,
        TROUBLESHOOT_COMMON.sour,
        {
          symptom: 'Filtrare lentă, apă bălcește deasupra',
          cause: 'Măcinare prea fină → flow blocat; sau filtru fără pre-rinse.',
          fix: 'Grind mai grosier cu 2 clicks. Pre-rinse filtrul. Toarnă în spirale largi.'
        },
        {
          symptom: 'Cafea inegală în ceașcă',
          cause: 'Channeling — apa găsește căi rapide prin pat.',
          fix: 'După bloom, agită ușor pat cu lingura ("Rao spin"). Toarnă centrat, fără să atingi marginea.'
        },
        TROUBLESHOOT_COMMON.weak,
        TROUBLESHOOT_COMMON.astringent
      ]
    },

    chemex: {
      sweet: {
        dose: '30g', water: '500ml', ratio: '1:16.7',
        temp: '91°C', grind: 'Medie-grosieră', time: '4:30 — 5:00',
        steps: [
          'Pre-umezește filtrul GROS Chemex (rinse complet, aruncă apa).',
          'Bloom 60g apă (45s).',
          '3 reprize de 110g + 110g + 110g (intervale 40s).',
          'Total 4:30–5:00. Filtrul gros = body light.'
        ],
        tipsDo: [
          'Filtru Chemex pre-rinse — elimină gustul de hârtie.',
          'Vas sticlă pre-încălzit cu apă caldă.',
          'Servire imediată pentru flavor max.'
        ],
        tipsDont: [
          'NU folosi filtru subțire V60 în Chemex — flow prea rapid.',
          'NU toarna în spirale agresive — channeling.',
          'NU lăsa cafeaua peste 30 min în vas.'
        ]
      },
      balanced: {
        dose: '30g', water: '500ml', ratio: '1:16.7',
        temp: '93°C', grind: 'Medie', time: '4:00 — 4:30',
        steps: [
          'Pre-rinse filtru, aruncă apa.',
          'Bloom 60g (45s).',
          '4 reprize de 110g (intervale 30s).',
          'Total 4:00–4:30. Profil clean cu body suficient.'
        ],
        tipsDo: [
          'Apă cu mineralizare moderată pentru claritate maximă.',
          'Bloom 45s — disipare CO₂.',
          'Termometru pe vas pentru control temp.'
        ],
        tipsDont: [
          'NU toarna peste suprafața bobului — circular uniform.',
          'NU folosi grind prea fin — Chemex flow lent → over-extract.',
          'NU servi rece — Chemex pierde aroma sub 60°C.'
        ]
      },
      bright: {
        dose: '30g', water: '480ml', ratio: '1:16',
        temp: '95°C', grind: 'Medie', time: '3:30 — 4:00',
        steps: [
          'Pre-rinse filtru cu apă fierbinte.',
          'Bloom 60g (30s).',
          '3 reprize rapide 140g (intervale 25s).',
          'Total 3:30–4:00.'
        ],
        tipsDo: [
          'Temp ridicat (95°C) scoate aciditate complexă.',
          'Recomandat pe single origins African washed.',
          'Bloom mai scurt — păstrează top notes.'
        ],
        tipsDont: [
          'NU folosi cafea prăjită dark — devine bitter.',
          'NU pe co-fermentate — esteri se extrag agresiv.',
          'NU adăuga zahăr — strică profilul citric.'
        ]
      },
      troubleshoot: [
        TROUBLESHOOT_COMMON.bitter,
        TROUBLESHOOT_COMMON.sour,
        {
          symptom: 'Body prea slab, "ceai"',
          cause: 'Filtrul gros Chemex reține multe uleiuri + ratio diluat.',
          fix: 'Crește doza la 32g/500ml (1:15.6). Folosește cafea cu corp natural (Brazilia, naturals).'
        },
        {
          symptom: 'Gust de hârtie',
          cause: 'Filtru ne-clătit înainte de cafea.',
          fix: 'Rinse abundent filtrul cu apă fierbinte (~200ml), aruncă apa, apoi cafeaua.'
        },
        TROUBLESHOOT_COMMON.flat,
        {
          symptom: 'Filtrul se strânge pe pereți (clogging)',
          cause: 'Grind prea fin pentru filtrul gros.',
          fix: 'Trece la măcinare medie (similar zahăr brut), nu fină ca V60.'
        }
      ]
    },

    frenchpress: {
      sweet: {
        dose: '28g', water: '500ml', ratio: '1:18',
        temp: '92°C', grind: 'Grosieră', time: '5:00 imersie',
        steps: [
          'Pre-încălzește vasul French Press cu apă caldă.',
          '28g cafea grosieră + 500ml apă 92°C.',
          'Stir lent la 1 minut. Așteaptă 5:00 total.',
          'Press lent (15s). Servire imediată.'
        ],
        tipsDo: [
          'Ratio diluat (1:18) pentru body curat fără asprime.',
          'Apă filtrată — French Press extrage minerale.',
          'Decantează imediat după press.'
        ],
        tipsDont: [
          'NU folosi grind fin — particule în ceașcă + over-extract.',
          'NU lăsa peste 6 min — bitter.',
          'NU presa rapid — agită sedimentele.'
        ]
      },
      balanced: {
        dose: '30g', water: '500ml', ratio: '1:16.7',
        temp: '95°C', grind: 'Grosieră', time: '4:00 imersie',
        steps: [
          'Vas pre-încălzit.',
          '30g cafea + 500ml apă 95°C.',
          'Stir gentle la 1 min. Imersie 4:00.',
          'Press lent. Decantează imediat.'
        ],
        tipsDo: [
          'Setting clasic French Press.',
          'Apasă plonjor doar pentru a separa — fără presiune.',
          'Folosește grind consistent (grosieră uniformă).'
        ],
        tipsDont: [
          'NU presa plonjor până la fund cu forță.',
          'NU lăsa cafea în vas după press — continuă să extragă.',
          'NU folosi grind fin — inevitabil sediment.'
        ]
      },
      bright: {
        dose: '32g', water: '500ml', ratio: '1:15.6',
        temp: '95°C', grind: 'Grosieră', time: '4:00 fără stir',
        steps: [
          'Vas pre-încălzit.',
          '32g cafea grosieră + 500ml apă 95°C.',
          'FĂRĂ STIR. Imersie 4:00 statică.',
          'Sparge crusta, ridică-o cu lingura. Press lent.'
        ],
        tipsDo: [
          'Skip stir = sedimente la fund, ceașcă mai cleaner.',
          'Ratio concentrat (1:15.6) pentru aciditate vibrantă.',
          'Ideal cu Kenya washed sau Etiopia natural.'
        ],
        tipsDont: [
          'NU stir-ui — invalidează profile bright.',
          'NU prelungi peste 4:30 — bitter inevitabil.',
          'NU folosi pe natural Brazilian — body devine prea heavy.'
        ]
      },
      troubleshoot: [
        TROUBLESHOOT_COMMON.bitter,
        TROUBLESHOOT_COMMON.sour,
        {
          symptom: 'Sediment / nămol în ceașcă',
          cause: 'Grind prea fin sau plonjor apăsat brutal.',
          fix: 'Grind grosier ca sare grunjoasă. Plonjor lent, fără forță. Decantează prin sită fină.'
        },
        {
          symptom: 'Body prea greu, "muddy"',
          cause: 'Imersie peste 5 min sau cafea lăsată în press după turnare.',
          fix: 'Toarnă tot în cești după press. Reduce timpul la 4:00.'
        },
        TROUBLESHOOT_COMMON.weak,
        {
          symptom: 'Crustă uscată deasupra după 4 min',
          cause: 'Saturare neuniformă la pornire.',
          fix: 'Toarnă apă cu putere ca să saturezi toate boabele. Stir scurt la 30s.'
        }
      ]
    },

    espresso: {
      sweet: {
        dose: '18g IN', water: '45g OUT', ratio: '1:2.5',
        temp: '90°C', grind: 'Foarte fină', time: '30 — 35s',
        steps: [
          'Pre-infuzie LONG 6–8s (presiune scăzută).',
          'Ratio 1:2.5 — yield mai mare = dulceață amplificată.',
          'Temp 90°C — sub standard.',
          'Servire imediată.'
        ],
        tipsDo: [
          'Pre-infuzie 6–8s critică pentru saturare uniformă.',
          'Bottomless portafilter pentru verificare extracție.',
          'Tamping consistent ~15 kg.'
        ],
        tipsDont: [
          'NU coborî sub 88°C — under-extract, sour.',
          'NU folosi grind prea fin — gushing/channeling.',
          'NU servi cu lapte cald — strică profilul dulce.'
        ]
      },
      balanced: {
        dose: '18g IN', water: '36g OUT', ratio: '1:2',
        temp: '92°C', grind: 'Foarte fină', time: '26 — 30s',
        steps: [
          'Pre-infuzie 4–6s.',
          'Ratio 1:2 clasic.',
          'Temp 92°C standard.',
          'Watch curgerea — nu sub 25s sau peste 32s.'
        ],
        tipsDo: [
          'Setting standard pentru majoritatea cafelelor.',
          'Pre-infuzie 4–6s = consistență.',
          'Cântar pe ceașcă — exact 36g out.'
        ],
        tipsDont: [
          'NU schimba grind fără să refaci extracția.',
          'NU adăuga apă în ceașcă — strică ratio.',
          'NU servi rece — espresso pierde sub 50°C în 60s.'
        ]
      },
      bright: {
        dose: '18g IN', water: '32g OUT', ratio: '1:1.8',
        temp: '93°C', grind: 'Foarte fină+', time: '24 — 28s',
        steps: [
          'Pre-infuzie 4–5s scurtă.',
          'Ratio ristretto-style 1:1.8 — concentrat.',
          'Temp 93°C max.',
          'Servire imediată — bright e fragil.'
        ],
        tipsDo: [
          'Pentru washed Etiopia / Kenya cu aciditate vibrantă.',
          'Pulled fast — top notes preserve.',
          'Pre-heat ceașcă obligatoriu.'
        ],
        tipsDont: [
          'NU prelungi peste 30s — devine sour.',
          'NU folosi pe natural Brazilian — over-bright.',
          'NU adăuga lapte — strică profilul concentrat.'
        ]
      },
      troubleshoot: [
        {
          symptom: 'Arsă / amară puternică',
          cause: 'Over-extraction — grind prea fin, temp mare, sau ratio prea diluat (1:3+).',
          fix: 'Grind cu 1 click mai grosier. Scade temp la 90°C. Ține ratio 1:2 standard.'
        },
        {
          symptom: 'Sour / acid intens',
          cause: 'Under-extraction — pulled prea repede (<22s) sau temp prea joasă.',
          fix: 'Grind mai fin. Ridică temp la 93°C. Țintă: 26–30s pentru 36g out.'
        },
        {
          symptom: 'Channeling (jeturi laterale, spray)',
          cause: 'Distribuire neuniformă a cafelei în portafilter sau tamping inegal.',
          fix: 'Folosește WDT tool (ace fine). Tamping vertical, presiune 15 kg. Nu răsuci tamper-ul.'
        },
        {
          symptom: 'Crema palidă / blondă imediat',
          cause: 'Cafea veche (>30 zile) sau prăjire light care nu produce crema densă.',
          fix: 'Folosește blend espresso fresh (7–21 zile). Verifică data prăjirii.'
        },
        {
          symptom: 'Espresso curge prea repede (<20s)',
          cause: 'Grind prea grosier sau dose prea mică.',
          fix: 'Grind cu 2 clicks mai fin. Verifică dose 18g IN. Re-tamping.'
        },
        {
          symptom: 'Espresso nu pornește / curge picătură',
          cause: 'Grind prea fin sau dose prea mare (over-dose).',
          fix: 'Grind cu 2 clicks mai grosier. Verifică headspace minim 3 mm sub duș.'
        }
      ]
    },

    ibric: {
      sweet: {
        dose: '7g', water: '100ml', ratio: '1:14 + zahăr',
        temp: 'Apă rece la start', grind: 'Pulbere fină', time: '~5 min',
        steps: [
          '7g cafea pulbere + 100ml apă rece + 1 linguriță zahăr.',
          'Foc mic. Lasă spuma să se ridice fără să fiarbă.',
          'Ia de pe foc, lasă spuma să cadă (3 secunde).',
          'Repetă: 3 răscoaceri. Servire în filigian.'
        ],
        tipsDo: [
          'Zahărul la apa rece, NU după.',
          'Tradiție turcească — răscoacerea repetată dezvoltă spuma.',
          'Servire imediată cu apă rece alături.'
        ],
        tipsDont: [
          'NU lăsa să fiarbă — distruge profilul.',
          'NU agita după prima răscoacere.',
          'NU folosi cafea ne-pulberizată — particule mari = under-extract.'
        ]
      },
      balanced: {
        dose: '7g', water: '100ml', ratio: '1:14',
        temp: 'Apă rece la start', grind: 'Pulbere fină', time: '~4 min',
        steps: [
          '7g cafea pulbere + 100ml apă rece, fără zahăr.',
          'Foc mic. Prima răscoacere — spumă densă.',
          'Pauză 3s, răscoacere a doua.',
          'Servire în filigian; zahăr la alegere.'
        ],
        tipsDo: [
          'Setting tradițional fără zahăr — adevăratul profil.',
          'Cafea de specialitate pe ibric = experiment editorial.',
          'Servire cu apă rece pe alături (curăță palatul).'
        ],
        tipsDont: [
          'NU adăuga zahăr după prima răscoacere — strică spuma.',
          'NU servi fără sediment la fund — face parte din ritual.',
          'NU folosi grinder slab — ibric cere pulbere consistentă.'
        ]
      },
      bright: {
        dose: '8g', water: '90ml', ratio: '1:11.25',
        temp: 'Apă rece la start', grind: 'Pulbere fină', time: '~5 min',
        steps: [
          '8g cafea pulbere + 90ml apă (ratio concentrat).',
          'Foc mic. 3 răscoaceri pentru spumă densă.',
          'Pauză 5s între răscoaceri.',
          'Servire în filigian mic, sip lent.'
        ],
        tipsDo: [
          'Concentrat pentru punch maxim.',
          'Folosește single origin Kenya/Etiopia pentru aciditate.',
          'Cub zahăr separat — alege bea-torul.'
        ],
        tipsDont: [
          'NU folosi blend cu Robusta — devine pulbere amară.',
          'NU răscoace peste 3 ori — pierde aroma.',
          'NU folosi pe natural Brazilian — body devine sufocant.'
        ]
      },
      troubleshoot: [
        TROUBLESHOOT_COMMON.bitter,
        {
          symptom: 'Spumă subțire sau absentă',
          cause: 'Apă fierbinte la pornire, foc prea mare, sau pulbere prea grosieră.',
          fix: 'Apă rece obligatoriu. Foc mic-mediu. Grind cât mai fin (sub espresso).'
        },
        {
          symptom: 'Cafea fiartă / gust ars',
          cause: 'Lăsat să clocotească peste prima ridicare a spumei.',
          fix: 'Scoate ibricul de pe foc IMEDIAT ce spuma începe să urce. Niciodată să fiarbă.'
        },
        {
          symptom: 'Sediment dur, pastă în filigian',
          cause: 'Servire fără pauza de 1 min de odihnă.',
          fix: 'Lasă ibricul 1 min să se așeze sedimentul înainte de turnat. Sip lent.'
        },
        {
          symptom: 'Cafea apoasă, fără corp',
          cause: 'Ratio prea diluat sau grind insuficient de fin.',
          fix: 'Crește doza la 8g/90ml. Verifică grind — trebuie să fie aproape pudră.'
        }
      ]
    },

    aeropress: {
      sweet: {
        dose: '17g', water: '220ml', ratio: '1:13',
        temp: '88°C', grind: 'Medie-fină', time: '2:30 inverted',
        steps: [
          'Inverted method (capac jos).',
          '17g cafea + 30g apă 88°C, agitare 30s.',
          'Completare la 220ml. Steep 1:30.',
          'Flip pe ceașcă, plunge lent 30s. Total 2:30.'
        ],
        tipsDo: [
          'Temp lower (88°C) păstrează top notes fără asprime.',
          'Inverted method = control total pe timp.',
          'Filtru hârtie + rinse înainte.'
        ],
        tipsDont: [
          'NU plunge rapid — agitare disturbă sedimentele.',
          'NU folosi temp peste 92°C în AeroPress.',
          'NU folosi grind grosier — AP cere fine pentru presiune.'
        ]
      },
      balanced: {
        dose: '17g', water: '220ml', ratio: '1:13',
        temp: '91°C', grind: 'Medie-fină', time: '2:00 inverted',
        steps: [
          'Inverted method.',
          '17g cafea + 30g bloom 91°C, agitare 30s.',
          'Completare 220ml. Steep 1:00.',
          'Flip + plunge 30s. Total 2:00.'
        ],
        tipsDo: [
          'Setting standard AeroPress.',
          'Bloom critic — degazare uniformă.',
          'Filtru double pentru cleanliness extra (optional).'
        ],
        tipsDont: [
          'NU sări bloom — extracție inegală.',
          'NU plunge cu putere — filter rupe.',
          'NU folosi după 14 zile post-prăjire.'
        ]
      },
      bright: {
        dose: '18g', water: '200ml', ratio: '1:11',
        temp: '93°C', grind: 'Medie-fină', time: '1:30 standard',
        steps: [
          'STANDARD method (capac sus).',
          '18g cafea + 200ml apă 93°C, stir 5s.',
          'Steep 1:00 cu capac închis.',
          'Plunge rapid 20s. Total 1:30.'
        ],
        tipsDo: [
          'Standard (vs inverted) = extracție rapidă.',
          'Concentrat pentru aciditate vibrantă.',
          'Recomandat Kenya/Etiopia washed.'
        ],
        tipsDont: [
          'NU folosi pe co-fermentate — tanin scoate prea repede.',
          'NU prelungi peste 1:45 — bitter inevitabil.',
          'NU adăuga apă post — strica concentrarea.'
        ]
      },
      troubleshoot: [
        TROUBLESHOOT_COMMON.bitter,
        TROUBLESHOOT_COMMON.sour,
        {
          symptom: 'Plonjor blocat / greu de apăsat',
          cause: 'Măcinare prea fină → presiune ridicată.',
          fix: 'Grind mai grosier cu 1 click. Apăsă lent, constant — nu cu forță.'
        },
        {
          symptom: 'Sediment / particule deasupra',
          cause: 'Plonjor apăsat prea adânc (aer trecut prin pat).',
          fix: 'Oprește când auzi sunetul de "hiss". Lasă ultimii 5% nepresati.'
        },
        TROUBLESHOOT_COMMON.weak,
        {
          symptom: 'Cafeaua picură pe sub capac',
          cause: 'Filtru pus invers sau capac neînfiletat complet.',
          fix: 'Cu lighter side a filtrului spre apă. Strânge capacul ferm.'
        }
      ]
    }
  };

  document.querySelectorAll('[data-page-brewing-calculator]').forEach(initCalc);

  function initCalc(root) {
    const method = root.dataset.method || 'v60';
    const profileBtns = root.querySelectorAll('[data-profile]');
    const recipeOutput = root.querySelector('[data-recipe-output]');

    if (!RECIPES[method]) {
      console.warn('[brewing-calculator] No recipes for method:', method);
      return;
    }

    profileBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const profile = btn.dataset.profile;
        switchProfile(profile);
      });
    });

    renderTroubleshoot(RECIPES[method].troubleshoot || []);
    switchProfile('balanced');

    function switchProfile(profile) {
      const recipe = RECIPES[method][profile];
      if (!recipe) return;

      root.dataset.activeProfile = profile;

      profileBtns.forEach(function (btn) {
        const isActive = btn.dataset.profile === profile;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-checked', String(isActive));
      });

      recipeOutput.classList.add('is-swapping');
      setTimeout(function () {
        renderRecipe(recipe);
        recipeOutput.classList.remove('is-swapping');
      }, 180);
    }

    function renderRecipe(recipe) {
      ['dose', 'water', 'ratio', 'temp', 'grind', 'time'].forEach(function (key) {
        const el = root.querySelector('[data-param="' + key + '"]');
        if (el) el.textContent = recipe[key] || '—';
      });

      const stepsEl = root.querySelector('[data-param="steps"]');
      if (stepsEl && recipe.steps) {
        stepsEl.innerHTML = recipe.steps.map(function (s) { return '<li>' + s + '</li>'; }).join('');
      }

      const doEl = root.querySelector('[data-tips-do]');
      if (doEl && recipe.tipsDo) {
        doEl.innerHTML = recipe.tipsDo.map(function (s) { return '<li>' + s + '</li>'; }).join('');
      }
      const dontEl = root.querySelector('[data-tips-dont]');
      if (dontEl && recipe.tipsDont) {
        dontEl.innerHTML = recipe.tipsDont.map(function (s) { return '<li>' + s + '</li>'; }).join('');
      }
    }

    function renderTroubleshoot(items) {
      const grid = root.querySelector('[data-troubleshoot]');
      if (!grid || !items.length) return;
      grid.innerHTML = items.map(function (item, i) {
        const num = String(i + 1).padStart(2, '0');
        return '' +
          '<article class="page-brewing-calculator__diag-card">' +
            '<span class="page-brewing-calculator__diag-num" aria-hidden="true">' + num + '</span>' +
            '<h4 class="page-brewing-calculator__diag-symptom">' + escapeHtml(item.symptom) + '</h4>' +
            '<dl class="page-brewing-calculator__diag-meta">' +
              '<dt>Cauză</dt><dd>' + escapeHtml(item.cause) + '</dd>' +
              '<dt>Reparație</dt><dd>' + escapeHtml(item.fix) + '</dd>' +
            '</dl>' +
          '</article>';
      }).join('');
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
  }
})();
